import type { FinancialFormula, FinancialFormulaCategory, FinancialFormulaToken } from '../../types';

export const financialFormulaOperand = (
    key: string,
    label: string,
    category: FinancialFormulaCategory,
): FinancialFormulaToken => ({ category, key, label, type: 'operand' });

export const financialFormulaOperator = (value: '(' | ')' | '+' | '−' | '×' | '÷' | '='): FinancialFormulaToken => ({
    type: 'operator',
    value,
});

export const createFinancialFormula = (...tokens: FinancialFormulaToken[]): FinancialFormula => ({ tokens });
